$(document).ready(function() {
	const $button = $('.scroll-to-top');

	if (!$button.length) {
		return;
	}

	const scrollThreshold = 120;

	function updateButtonVisibility() {
		const isVisible = window.scrollY > scrollThreshold;

		$button.toggleClass('is-visible', isVisible);
		$button.prop('hidden', !isVisible);
	}

	$button.on('click', function() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});

	updateButtonVisibility();
	$(window).on('scroll', updateButtonVisibility);
});
